import React, { memo } from 'react';

import { Page } from '@betty/navigation';
import { DailyScratcher } from '../../index';

function DailyScratcherModal() {
  return (
    <Page>
      <DailyScratcher />
    </Page>
  );
}

export default memo(DailyScratcherModal);
